<template>
    <Card title="Boletos Pagos" icon="ion ion-ios-document">
        <div v-if="!btn_load">
            <button class="btn btn-block btn-lg btn-secondary" @click="$refs.modalBoletosPagos.open()">IR</button>
        </div>
        <div v-else class="col-md-12 d-flex justify-content-center">
            <div class="btn-toolbar d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
            </div>
        </div>

        <vuestic-modal ref="modalBoletosPagos" :cancelClass="'none'" :okClass="'none'">
            <div slot="title">Boletos Pagos</div>
            <div v-if="!btn_load">
                <input type="month" v-model="input_mes" class="form-control" placeholder="ex: yyyy-mm">
                <button v-if="!btn_download" class="btn btn-block btn-lg btn-secondary" @click="loadData('pdf')">PDF</button>
                <button v-else class="btn btn-block btn-lg btn-secondary" disabled>PDF</button>
                <button v-if="!btn_download" class="btn btn-block btn-lg btn-secondary" @click="loadData('csv')">CSV</button>
                <button v-else class="btn btn-block btn-lg btn-secondary" disabled>CSV</button>
                <button v-if="!btn_download" class="btn btn-block btn-lg btn-secondary" @click="loadData('xlsx')">XLSX</button>
                <button v-else class="btn btn-block btn-lg btn-secondary" disabled>XLSX</button>
            </div>
            <div v-else class="col-md-12 d-flex justify-content-center">
                <div class="btn-toolbar d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
                </div>
            </div>
        </vuestic-modal>
    </Card>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../../../router/urlApiV2'
import Card from '../../../cards/card.vue';

export default {
    name: 'relatorioAdmin',
    components: {
        ...spinners,
        Card,
    },

    data () {
        return {
            btn_load:       false,
            btn_download:   false,
            input_mes:      '',
        }
    },

    methods:{
        loadData(type){
            this.btn_load   =   true;
            if(this.input_mes == '') {
                this.$toasted.show('Informe o mês desejado!', {
                    position: 'top-right',
                })
                this.btn_load   =   false;
                return
            }
            let now = new Date();
            let input_date = new Date(this.input_mes);
            if ( !( input_date.getFullYear() < now.getFullYear() || ( input_date.getFullYear() === now.getFullYear() && input_date.getMonth() < now.getMonth() ) ) ) {
                this.$toasted.show('Mês informado não pode ser maior do que o mês atual!', {
                    position: 'top-right',
                })
                this.btn_load   =   false;
                return
            }
            if(type == 'pdf') {
                let url =   urlApi + '/faturamento/exportar/boletos-pagos?tipo=pdf&periodo='+this.input_mes;
                this.$http.get(url)
                .then(this.callBackLoadDataPDF)
                .catch(function (error) {
                    this.btn_load   =   false;
                    this.$toasted.show(error.data.mensagem, {
                        position: 'top-right',
                    })
                })
            } else if(type == 'csv') {
                let url =   urlApi + '/faturamento/exportar/boletos-pagos?tipo=csv&periodo='+this.input_mes;
                this.$http.get(url)
                .then(this.callBackLoadDataCSV)
                .catch(function (error) {
                    this.btn_load   =   false;
                    this.$toasted.show(error.data.mensagem, {
                        position: 'top-right',
                    })
                })
            }else if(type == 'xlsx') {
                let anchor = document.createElement("a");
                document.body.appendChild(anchor);

                this.$http.get(urlApi + '/faturamento/exportar/boletos-pagos?&tipo=xlsx&periodo='+this.input_mes, {responseType: 'blob'})
                .then(response => response.blob())
                .then(responseBlob => {
                    console.log(responseBlob)
                    let objectUrl = window.URL.createObjectURL(responseBlob);
                    anchor.href = objectUrl;
                    anchor.download = 'boletos-pagos.xlsx';
                    anchor.click();
                    window.URL.revokeObjectURL(objectUrl);
                    this.btn_load = false;
                });
            }
        },
        callBackLoadDataPDF(response) {
            this.downloadPDF(response.body)
            this.btn_load   =   false;
        },
        callBackLoadDataCSV(response) {
            this.downloadCSV(response.body)
            this.btn_load   =   false;
        },
        downloadPDF (response) {
        let code64 = response
        var pdf = 'data:application/octet-stream;base64,' + code64
        var dlnk = document.getElementById('download')
        dlnk.download = 'alunos-faturas.pdf'
        dlnk.href = pdf
        dlnk.click()
        },
        downloadCSV(response) {
            var dlnk = document.getElementById('download');
            dlnk.download="alunos-faturas.csv";
            dlnk.href = 'data:text/csv;charset=utf-8,' + response;
            dlnk.click();
        },
    }
}
</script>
